import gql from 'graphql-tag';

const UPDATE_REALTOR_APPOINTMENT = gql` 
  mutation updateRealtorAppointment($input: RealtorAppointmentUpdateInput!) {
    updateRealtorAppointment(input: $input) {
      message
      code
    }
  }
`;

export default UPDATE_REALTOR_APPOINTMENT;